<page-toolbar title="{{'pages.contact' | translate}}"></page-toolbar>

<page-content [noPadding]="true">
  <div *ngIf="!loading" class="container">
    <div class="dynamic-data">
      <div class="menu-buttons">
        <div class="menu-button" *ngFor="let item of buttons; let i = index" (click)="openTab(item)" [ngClass]="{'active': selectedTab === item}" [id]="item">
          {{'contact.' + item | translate}}
        </div>
      </div>
      <div class="dynamic-data-content">

        <div class="header">
          <div class="title">{{'contact.' + selectedTab | translate}}</div>

          <div class="actions">
            <button (click)="add()" matTooltip="{{'dynamicContent.addEntry' | translate}}" matTooltipPosition="left">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <div class="sub-header">
          <div class="title">Titel</div>
          <div class="created">{{ 'general.created' | translate }}</div>
          <div class="actions"></div>
        </div>

        <div *ngIf="!!data?.length" class="list">
          <div *ngFor="let item of data" class="item" (click)="edit(item, $event)">
            <div class="title">{{item.title}}</div>
            <div class="created" *ngIf="!!item?.created">{{item?.created | date:'dd.MM.YYYY'}}</div>
            <div class="actions">
              <button (click)="edit(item, $event)"><mat-icon>edit</mat-icon></button>
              <button (click)="remove(item, $event)"><mat-icon>delete</mat-icon></button>
            </div>
          </div>
        </div>
        <div class="empty" *ngIf="!data?.length">{{ 'dynamicContent.noEntries' | translate }}</div>

      </div>
    </div>
  </div>

  <div *ngIf="loading" class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</page-content>
